const SESSION_ROUTE_PREFIXES = [
  '/categories',
  '/cart',
  '/checkout',
  '/confirm',
  '/orders',
  '/menus',
  '/fulfillment',
  '/delivery',
  '/branches',
  '/tables',
  '/profile',
  '/help',
  '/info',
  '/expired',
]

function normalizeAppPath(path: string) {
  const withoutLocale = path.replace(/^\/(fr|it|de|hy|ru)(?=\/|$)/, '')
  const normalized = withoutLocale.startsWith('/') ? withoutLocale : `/${withoutLocale}`
  return normalized.replace(/\/+$/, '') || '/'
}

function needsScannedSession(path: string) {
  const current = normalizeAppPath(path)
  return SESSION_ROUTE_PREFIXES.some(
    (route) => current === route || current.startsWith(`${route}/`)
  )
}

export default defineNuxtRouteMiddleware((to) => {
  if (process.server || to.path.startsWith('/_')) return

  const id = useSafeStorage('_id')
  const access_token = useSafeStorage('access_token')
  const lang = normalizeAppLocale(useSafeStorage('i18n_redirected')) || 'en'

  const config = useRuntimeConfig()
  const appEnv = config.public.appEnv

  // Normalize current route name
  const currentName = to.name?.toString().split('___')[0] || ''

  // Base path helper to prevent "//" or invalid paths
  const localePath = (path: string) => {
    const prefix = (lang && lang !== 'en') ? `/${lang}` : ''
    return `${prefix}${path}`.replace(/\/+/g, '/') // regex cleans up double slashes
  }

  if (!id && needsScannedSession(to.path)) {
    const hostSlug = getRestaurantSlugFromHost(to.query as Record<string, any>)
    if (hostSlug) {
      const pathLocale = to.path.match(/^\/(fr|it|de|hy|ru)(?=\/|$)/)?.[0]
      const prefix = pathLocale || ((lang && lang !== 'en') ? `/${lang}` : '')
      const query = appEnv !== 'prod' ? `?slug=${encodeURIComponent(hostSlug)}` : ''
      return navigateTo(`${prefix}/${query}`.replace(/\/{2,}/g, '/'), { replace: true })
    }
  }

  const landingRoutes = ['index', 'privacy-policy', 'terms-of-use']
  if (landingRoutes.includes(currentName)) {
    useRemoveSafeStorage('_id')
  }

  const signInPath = localePath('/sign-in')
  if (to.path === signInPath && access_token) {
    return navigateTo(localePath('/profile'))
  }

  // const tablesPath = localePath('/tables')
  // if (to.path !== tablesPath) {
  //   useRemoveSafeStorage('pin_code')
  // } else if (!access_token) {
  //   return navigateTo(signInPath)
  // }

  const blockedPathsOnDesktop = ['/profile', '/cart', '/checkout']
  const isBlockedPath = blockedPathsOnDesktop.some(p => to.path === localePath(p) || to.path.startsWith(localePath(p) + '/'))
  if (isBlockedPath && window.innerWidth >= 1024) {
    const user = useSafeStorage('user')
    if (!user) {
      const dishesStore = useDishesStore()
      dishesStore.showLoginRequired = true
      return navigateTo(localePath('/categories'))
    }
  }
})